module.exports = __webpack_public_path__ + "img/9788954615860.3052c5a2.jpg";